import { FaCcMastercard } from 'react-icons/fa';

const MasterCard = ({ size = 48, color = "#eb001b" }) => {
    return <FaCcMastercard size={size} color={color} />
}

export default MasterCard